import Network from "./Network";

const PostFaqQuery = async (faq) => {
  const response = await Network().post("/faq" , faq)
    console.log("PostFaqQuery" , response.status)
}

export default PostFaqQuery
